"use client";
import { useLocaleContext, useTranslation } from "@/app/i18n/client";
import Link from "next/link";

export default function UnlockButton({
  busrequestId,
  className,
}: {
  busrequestId: string;
  className?: string;
}) {
  const lng = useLocaleContext();
  const { t } = useTranslation("busrequests");
  return (
    <Link
      className={`text-nowrap rounded-md bg-matchbus p-2 text-secondary ${className ?? ""}`}
      href={`/${lng}/checkout/${busrequestId}`}
    >
      {t("ACTIONS.UNLOCK")}
    </Link>
  );
}
